import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import CreateClientPage from './pages/dashboard/CreateClient';
import HomePage from './pages/HomePage';
import StayPage from './pages/StayPage';
import GalleryPage from './pages/GalleryPage';
import OurStoryPage from './pages/OurStoryPage';
import EnquiryPage from './pages/EnquiryPage';
import DashboardPage from './pages/dashboard/Dashboard';
import LoginPage from './pages/LoginPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/stay" element={<StayPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/our-story" element={<OurStoryPage />} />
      <Route path="/enquiry" element={<EnquiryPage />} />
      <Route path="/login" element={<LoginPage />} />
      
      {/* Protected Admin Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/dashboard/create-client" element={<CreateClientPage />} />
      </Route>
    </Routes>
  );
}
